var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowExternalFormCTA())?_c('a',{staticClass:"ExternalFormCTA",attrs:{"margin":_vm.margin,"href":_vm.NETHERLANDS.externalFormCTALink}},[_vm._v(" "+_vm._s(_vm.$t('homepage.google_cta'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }